// extracted by mini-css-extract-plugin
export default {"banner":"FlipTabletBanner--banner--af1392"};